import auth from '@api/auth' //eslint-disable-line
import Vue from 'vue'
import clientsApi from '@api/clients' //eslint-disable-line

export default {
    namespaced: true,
    state: {
        user: null,
        logoutTimestamp: null,
        accountPlan: null,
    },
    getters: {
        hasFeature: ({ user }) => feature => user.features?.includes(feature),
        hasScope: ({ user }) => scope => {
            const userScopes = user?.scopes ?? [];
            const gateScopes = user?.gates?.scope ?? [];
            return userScopes.includes(scope) || gateScopes.includes(scope);
        },
        user: ({ user }) => user,
        userFullName: ({ user }) => (user ? `${user.first_name} ${user.last_name}` : null),
        logoutTimestamp: ({ logoutTimestamp }) => logoutTimestamp,
        canManageAllClicksProducts: (state, getters) => getters.hasScope('manage-all-clicks-products'),
        isClicksManager: ({ user }) => !user.roles.every(role => role.code !== 'clicks_manager'),
        isExternalClient: ({ user }) => user.scopes.some(scope => scope === 'external-client'),
        isEngineer: ({ user }) => !user.roles.every(role => role.code !== 'software_engineer'),
        accountPlan: ({ accountPlan }) => accountPlan,
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setLogoutTimestamp(state, timestamp) {
            state.logoutTimestamp = timestamp
        },
        setAccountPlan(state, plan) {
            Vue.set(state, 'accountPlan', plan)
        },
    },
    actions: {
        refreshLogin({ commit }) {
            return auth.me()
                .then(response => {
                    commit('setUser', response?.data?.data)
                })
        },
        logout({ commit }) {
            return auth.logout()
                .then(() => {
                    commit('setUser', null)
                })
        },
        setLogoutTimestamp({ commit }, timestamp) {
            commit('setLogoutTimestamp', parseInt(timestamp, 10) * 1000)
        },
        getAccountPlan({ commit }, accountUuid) {
            return clientsApi.getClientAccountPlan(accountUuid)
                .then(response => {
                    commit('setAccountPlan', response?.data?.data?.plan)
                })
        },
    },
}
